import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, LanguageIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../providers/LanguageProvider';
import clsx from 'clsx';

export const LanguageSelector: React.FC = () => {
  const { currentLanguage, changeLanguage, supportedLanguages, isLoading } = useLanguage();
  
  const currentLangInfo = supportedLanguages[currentLanguage as keyof typeof supportedLanguages] || supportedLanguages.en;

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button 
          className="inline-flex items-center justify-center gap-x-2 rounded-lg bg-white dark:bg-gray-800 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
          disabled={isLoading}
        >
          <LanguageIcon className={clsx("h-5 w-5", isLoading && "animate-spin")} />
          <span className="hidden sm:inline">{currentLangInfo.flag} {currentLangInfo.name}</span>
          <span className="sm:hidden">{currentLangInfo.flag}</span>
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {Object.entries(supportedLanguages).map(([code, info]) => (
              <Menu.Item key={code}>
                {({ active }) => (
                  <button
                    onClick={() => changeLanguage(code)}
                    className={clsx(
                      active ? 'bg-gray-100 dark:bg-gray-700' : '',
                      currentLanguage === code ? 'font-semibold text-indigo-600 dark:text-indigo-400' : 'text-gray-700 dark:text-gray-200',
                      'group flex items-center px-4 py-2 text-sm w-full text-left transition-colors'
                    )}
                    dir={info.dir}
                  >
                    <span className="mr-3">{info.flag}</span>
                    {info.name}
                    {currentLanguage === code && (
                      <span className="ml-auto text-indigo-600 dark:text-indigo-400">✓</span>
                    )}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default LanguageSelector;